export default __webpack_public_path__ + "static/media/front-right-wheel.77ccbdb3.svg";